<template>
    <div class="card-challenge-leaderboard-flank">
        <div class="card-challenge-leaderboard-flank__wr-user-img">
            <img class="card-challenge-leaderboard-flank__user-img" :src="userImageLink">
            <span class="card-challenge-leaderboard-flank__user-img-shadow"></span>
            <span class="card-challenge-leaderboard-flank__rank">
                <span class="card-challenge-leaderboard-flank__rank-value">{{ this.leaderboardItem.rank }}</span>
            </span>
        </div>
        <span class="card-challenge-leaderboard-flank__username">{{ this.leaderboardItem.username }}</span>
        <div class="card-challenge-leaderboard-flank__stat-win">
            <span class="card-challenge-leaderboard-flank__stat-win-value">{{ this.leaderboardItem.stats.win }}</span>
            <span class="card-challenge-leaderboard-flank__stat-win-icon"></span>
        </div>
        <div class="card-challenge-leaderboard-flank__stat-loss">
            <span class="card-challenge-leaderboard-flank__stat-loss-icon"></span>
            <span class="card-challenge-leaderboard-flank__stat-loss-value">{{ this.leaderboardItem.stats.loss }}</span>
        </div>
        <div
            class="card-challenge-leaderboard-flank__ranking-gem"
            :class="this.rankingClass">
            <span class="card-challenge-leaderboard-flank__ranking-gem-icon"></span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            leaderboardItem: {
                type: Object,
                default: {
                    id: 2,
                    username: "testuser101214",
                    rank: 2,
                    stats: {
                        win: 34,
                        loss: 12
                    }
                }
            }
        },

        computed: {
            rankingClass(){
                return `card-challenge-leaderboard-flank__rank-${this.leaderboardItem.rank}`;
            },

            userImageLink(){
                // return this.$store.state.api.img + this.leaderboardItem.id + '.jpg';
                return this.$store.state.api.getImage + this.leaderboardItem.id;
            },
        },
    };
</script>
<style scoped src="@/css/components/card-challenge-leaderboard-flank.css"></style>